/** Number of non-default filters, shown as a badge on the mobile Filters button. */
export function countActiveFilters(
  status: string,
  selectedUserIds: number[],
  selectedAccountIds: string[],
): number {
  let count = 0
  if (status !== "all") count++
  if (selectedUserIds.length > 0) count++
  if (selectedAccountIds.length > 0) count++
  return count
}
